import MultiModal from "./MultiModal";

export default MultiModal;
